'use client';
import { HttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { ApolloClient, InMemoryCache } from '@apollo/experimental-nextjs-app-support';
import { useApiStore } from '@shady-pines/api';
import { createBrowserClient } from '@supabase/ssr';
import { publicConfig } from '../config';

export const supabase = createBrowserClient(
  publicConfig.NEXT_PUBLIC_SUPABASE_URL,
  publicConfig.NEXT_PUBLIC_SUPABASE_ANON_KEY,
);

useApiStore.setState({
  supabase,
});

export const apollo = (initialState?: string) => {
  const url = `${publicConfig.NEXT_PUBLIC_SUPABASE_URL}graphql/v1`;

  const httpLink = new HttpLink({
    uri: url,
  });

  const authLink = setContext(async (_, prevContext) => {
    const token = (await supabase.auth.getSession()).data.session?.access_token;
    return {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      headers: {
        ...prevContext.headers,
        Authorization: token ? `Bearer ${token}` : '',
        apikey: publicConfig.NEXT_PUBLIC_SUPABASE_ANON_KEY,
      },
    };
  });

  return new ApolloClient({
    link: authLink.concat(httpLink),
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    cache: new InMemoryCache().restore(initialState ? JSON.parse(initialState) : {}),
  });
};
